// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2MUfv","boxTitle":"Qualiphy_boxTitle__3eyHA","box":"Qualiphy_box__2pUHe","toggleWrap":"Qualiphy_toggleWrap__29rFW"};